module.exports = __webpack_public_path__ + "img/icon_road1.9031e49f.png";